import {ActionButtonRow, HeadlineH1} from 'arkulpa-fec';
import gql from 'graphql-tag';
import {FlatButton} from 'material-ui';
import PropTypes from 'prop-types';
import React from 'react';
import {Mutation} from 'react-apollo';
import {withRouter} from 'react-router';
import TextField from 'material-ui/TextField/TextField';
import InputMask from 'react-input-mask';

const SAVE_DEVICE = gql`
  mutation saveDevice($deviceId: String!) {
    saveDevice(deviceId: $deviceId) {
      _id
      deviceId
      token
    }
  }
`;

const DeviceNew = ({history}) => {
  let input;
  return (
    <Mutation mutation={SAVE_DEVICE}>
      {(saveDevice, {data}) => {
        return (
          <div>
            <HeadlineH1>New device</HeadlineH1>
            <TextField
              type="text"
              fullWidth={true}
              floatingLabelText="DeviceId (Mac-adress)"
              ref={node => {
                input = node;
              }}>
              <InputMask mask="**-**-**-**-**-**" maskChar=" " />
            </TextField>
            <ActionButtonRow>
              <FlatButton onClick={() => history.push('/devices')} label="Back to list" />
              <FlatButton
                onClick={() => {
                  saveDevice({variables: {deviceId: input.input.value}})
                    .then(({data: {saveDevice: {_id}}}) => {
                      history.push('/device/' + _id);
                    })
                    .catch(err => {
                      console.log(err);
                    });
                }}
                label="save"
              />
            </ActionButtonRow>
          </div>
        );
      }}
    </Mutation>
  );
};
DeviceNew.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
DeviceNew.defaultProps = {
  maxRows: 30,
};

export default withRouter(DeviceNew);



// WEBPACK FOOTER //
// ./src/components/DeviceNew.js